import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Breadcrumb } from '@bingads-webui-react/breadcrumb';
import { getEntityBreadcrumbStyles } from '../../styles';

export function EntityBreadcrumb(props) {
  const {
    items,
    ...others
  } = props;

  const classes = useDefaultStyles(getEntityBreadcrumbStyles);
  const subItems = items.slice(-1);
  const mainItem = items.slice(0, items.length - 1);

  return (
    <div className={classNames('entity-breadcrumb', classes.container)}>
      {
        mainItem.length ?
          <div className={classNames('entity-breadcrumb-main', classes.main)}>
            <Breadcrumb items={mainItem} {...others} tooltipPlacement="bottom" />
          </div> : null
      }
      {
        subItems.length ?
          <div className={classNames('entity-breadcrumb-sub', classes.sub)}>
            <Breadcrumb items={subItems} {...others} tooltipPlacement="bottom" />
          </div> : null
      }
    </div>
  );
}

EntityBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
};
